import { filterCapitalize } from "@/filters/capitalize";
import { SelectItem } from "@/models/api/SelectItem";
import i18n from "@/plugins/i18n";

export enum CONTRACT_COMPONENT_TYPE_ENUM {
  None = 0,
  TradeContract = 1,
  CostContract = 2,
  Annex = 3,
  Calculation = 4,
}

export const contractorComponentTypes = [
  { value: CONTRACT_COMPONENT_TYPE_ENUM.TradeContract, text: filterCapitalize(i18n.t("tradeContract")) } as SelectItem,
  { value: CONTRACT_COMPONENT_TYPE_ENUM.CostContract, text: filterCapitalize(i18n.t("costContract")) } as SelectItem,
  { value: CONTRACT_COMPONENT_TYPE_ENUM.Annex, text: filterCapitalize(i18n.t("annex")) } as SelectItem,
  { value: CONTRACT_COMPONENT_TYPE_ENUM.Calculation, text: filterCapitalize(i18n.t("calculation")) } as SelectItem,
];
